import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {ChangeFunctionApproverGroupApprovalRequirement} from '../types'

export const ChangeFunctionApproverGroupApprovalRequirementsQueryKey =
  'change-function-approver-group-approval-requirements'

export const useChangeFunctionApproverGroupApprovalRequirements = (
  {plantId}: {plantId: string},
  options?: Omit<
    UseQueryOptions<ChangeFunctionApproverGroupApprovalRequirement[], AxiosError>,
    'queryKey'
  >
) => {
  return useQuery<ChangeFunctionApproverGroupApprovalRequirement[], AxiosError>({
    queryKey: [ChangeFunctionApproverGroupApprovalRequirementsQueryKey, plantId],
    queryFn: async ({signal}) => {
      const path = `/shifthandover/${plantId}/system-change-requests/change-function-approver-group-approval-requirements`
      const response = await ApiClient.axiosInstance.get<
        ChangeFunctionApproverGroupApprovalRequirement[]
      >(path, {signal})
      return response.data
    },
    ...options
  })
}
